import type { StatsSnapshot } from '../../../stats/gameplay-snapshot';
import { useGameStatsStore } from '../../zustand/useGameStatsStore';

export const seminaryReducer = (scratch: StatsSnapshot) => {
  const seminary = scratch.generators.seminary;

  // Only update if ticksCount is a multiple of ticksToGenerate
  const ticksToGenerate = seminary.ticksToGenerate ?? 1;

  if (useGameStatsStore.getState().getActiveTicksCount() % ticksToGenerate !== 0) {
    return;
  }

  const generatedClerics = seminary.owned * seminary.baseGeneration;

  // Apply upgrades somehow, somewhere...

  scratch.generators.cleric.owned += generatedClerics;

  return;
};
